// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  playerId: __t.string().primaryKey().name("player_id"),
  worldId: __t.string().name("world_id"),
  gold: __t.u32(),
  manpower: __t.u32(),
  supplies: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
